import { render, staticRenderFns } from "./NovaOsComponent.vue?vue&type=template&id=dc0bd456&scoped=true&"
import script from "./NovaOsComponent.vue?vue&type=script&lang=js&"
export * from "./NovaOsComponent.vue?vue&type=script&lang=js&"
import style0 from "./NovaOsComponent.vue?vue&type=style&index=0&id=dc0bd456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0bd456",
  null
  
)

export default component.exports